
/* eslint-disable sort-keys */
/* eslint-disable sort-keys-fix/sort-keys-fix */
/* eslint-disable max-len */

import {
  ContactHiddenFields,
  OrganizationSubType,
  OrganizationSubTypeForm,
} from '@common/entities';
import { FormFieldConfig, FormFieldKey, FormFieldValidator } from 'src/app/@shared/form/form.types';

export const INPUT_DEBOUNCE_TIME_MS = 300;

export const FORM_FIELD_SIMPLE: FormFieldConfig = {
  type: 'simple',
};

export const FORM_FIELD_SIMPLE_REQUIRED: FormFieldConfig = {
  ...FORM_FIELD_SIMPLE,
  validators: [
    {
      key: 'required',
    },
  ],
};

export const FORM_FIELD_READONLY: FormFieldConfig = {
  ...FORM_FIELD_SIMPLE,
  readOnly: true,
};

export const FORM_FIELD_HIDDEN: FormFieldConfig = {
  ...FORM_FIELD_SIMPLE,
  inputType: 'hidden',
};

export const FORM_FIELD_DYNAMIC: FormFieldConfig = {
  type: 'dynamic',
};

export const FORM_FIELD_DYNAMIC_REQUIRED: FormFieldConfig = {
  ...FORM_FIELD_DYNAMIC,
  validators: [
    {
      key: 'required',
    },
  ],
};

export const FORM_FIELD_SELECT: FormFieldConfig = {
  type: 'select',
  hasTranslation: true,
};

export const FORM_FIELD_SELECT_REQUIRED: FormFieldConfig = {
  ...FORM_FIELD_SELECT,
  validators: [
    {
      key: 'required',
    },
  ],
};

export const FORM_FIELD_SELECT_MODAL: FormFieldConfig = {
  type: 'selectModal',
};

export const FORM_FIELD_SELECT_MODAL_REQUIRED: FormFieldConfig = {
  ...FORM_FIELD_SELECT_MODAL,
  validators: [
    {
      key: 'required',
    },
  ],
};

// Regex is a result of a sample analysis of the nakos.de database (executed by myself) and created with ChatGPT 5.3
export const PHONE_NUMBER_VALIDATORS: FormFieldValidator[] = [
  {
    key: 'pattern',
    value: /^(?:\+49|0)[\d\s/-]{3,20}\d$/u,
  },
];

// Regex is a result of a sample analysis of the nakos.de database (executed by myself) and created with Gemini 2.5 pro
export const URL_VALIDATORS: FormFieldValidator[] = [
  {
    key: 'pattern',
    value: /^https?:\/\/(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(?:\/.*)?$/u, // positive examples: `https://www.myelom.org/forum`, `https://frauenbeauftragte.weibernetz.de`, `http://www.kids-22q11.de`
  },
];

export const EMAIL_VALIDATORS: FormFieldValidator[] = [
  {
    key: 'pattern',
    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/u,
  },
];

export type OrganizationSubTypeOption = OrganizationSubType | 'all';

export const SUB_TYPE_WITH_SUB_TYPE_FORMS: OrganizationSubType[] = ['selfHelpAddressRa', 'selfHelpAddressGa', 'selfHelpAddressCommunity', 'selfHelpAddressShGroup'];

export const FORM_FIELD_SELECT_OPTIONS_SUB_TYPE: OrganizationSubType[] = [...SUB_TYPE_WITH_SUB_TYPE_FORMS, 'selfHelpAddressBa', 'selfHelpAddressOther'];

export const FORM_FIELD_SELECT_OPTIONS_SUB_TYPE_FILTER: OrganizationSubType[] = [
  'selfHelpAddressRa',
  'selfHelpAddressGa',
  'selfHelpAddressCommunity',
  'selfHelpAddressShGroup',
  'selfHelpAddressBa',
  'selfHelpAddressOther',
];

export const FORM_FIELD_SELECT_OPTIONS_SUB_TYPE_FORM: OrganizationSubTypeForm[] = [
  'selfHelpAddressRa1a',
  'selfHelpAddressRa1b',
  'selfHelpAddressRa1c',
  'selfHelpAddressRa1d',
  'selfHelpAddressGa2a',
  'selfHelpAddressGa2b',
  'selfHelpAddressGa2c',
  'selfHelpAddressGa2d',
  'selfHelpAddressCommunity3a',
  'selfHelpAddressCommunity3b',
  'selfHelpAddressCommunity3c',
  'selfHelpAddressShGroup4a',
  'selfHelpAddressShGroup4b',
  'selfHelpAddressShGroup4c',
];

export const FORM_FIELD_SELECT_OPTIONS_SUB_TYPE_FORM_BY_ID: { [key in OrganizationSubTypeOption]: OrganizationSubTypeForm[] } = {
  all: FORM_FIELD_SELECT_OPTIONS_SUB_TYPE_FORM,
  selfHelpAddressRa: ['selfHelpAddressRa1a', 'selfHelpAddressRa1b', 'selfHelpAddressRa1c', 'selfHelpAddressRa1d'],
  selfHelpAddressGa: ['selfHelpAddressGa2a', 'selfHelpAddressGa2b', 'selfHelpAddressGa2c', 'selfHelpAddressGa2d'],
  selfHelpAddressCommunity: ['selfHelpAddressCommunity3a', 'selfHelpAddressCommunity3b', 'selfHelpAddressCommunity3c'],
  selfHelpAddressShGroup: ['selfHelpAddressShGroup4a', 'selfHelpAddressShGroup4b', 'selfHelpAddressShGroup4c'],
  selfHelpAddressBa: [],
  selfHelpAddressOther: [],
};

export const LOCKED_SEARCH_FORMS_BY_SUB_TYPE_FORM: Partial<Record<OrganizationSubTypeForm, OrganizationSubTypeForm[]>> = {
  selfHelpAddressCommunity3a: ['selfHelpAddressShGroup4c'],
  selfHelpAddressCommunity3b: ['selfHelpAddressShGroup4c'],
  selfHelpAddressCommunity3c: ['selfHelpAddressShGroup4c'],
  selfHelpAddressShGroup4a: ['selfHelpAddressShGroup4a'],
  selfHelpAddressShGroup4b: ['selfHelpAddressShGroup4b'],
  selfHelpAddressShGroup4c: ['selfHelpAddressShGroup4c'],
};

export const FORM_FIELD_SELECT_OPTIONS_CONTACT_HIDDEN_FIELDS: ContactHiddenFields[] = ['phoneNumber', 'email', 'name'];

export const FORM_FIELD_PAIRS: [FormFieldKey, FormFieldKey][] = [['providedByRed', 'providedByOther'], ['mainOffice', 'branchOffices']];

export type SelectOrganizationModalId = 'providedByRed' | 'providedByOther' | 'providesFor' | 'mainOffice' | 'branchOffices' | 'localContactPoint' | 'contactOrganization' | 'provider';
